// modules/dashboard/components/Piezas.js
// Piezas visuales del dashboard (estilos en styles/dashboard.css).
import { GRIS_NEUTRO, GRIS_OSCURO } from "../utils/colores";

export function pct(parte, total) {
  return total ? Math.round((parte / total) * 1000) / 10 : 0;
}

const fmt = new Intl.NumberFormat("es-CO");
export const num = (n) => fmt.format(n || 0);

export function EncabezadoSeccion({ id, emoji, titulo, total, acento, descripcion }) {
  return (
    <>
      <div className="db-seccion-cab" style={{ "--acento": acento }}>
        <div className="db-seccion-icono" aria-hidden="true">{emoji}</div>
        <h2 id={`${id}-titulo`}>{titulo}</h2>
        <span className="db-seccion-n">
          <i style={{ width: 8, height: 8, borderRadius: "50%", background: acento, display: "inline-block" }} />
          {num(total)} persona{total === 1 ? "" : "s"}
        </span>
      </div>
      {descripcion && <p className="db-seccion-desc">{descripcion}</p>}
    </>
  );
}

export function KpiRow({ items, acento }) {
  return (
    <div className="db-kpis" style={{ "--acento": acento }}>
      {items.map((it, i) => (
        <div key={i} className="db-kpi">
          <div className="db-kpi-valor">
            {it.valor}
            {it.unidad && <small>{it.unidad}</small>}
          </div>
          <div className="db-kpi-etq">{it.etiqueta}</div>
        </div>
      ))}
    </div>
  );
}

export function Tarjeta({ titulo, nota, ancho = 4, children }) {
  return (
    <div className={`db-tarjeta db-span-${ancho}`}>
      <h3>{titulo}</h3>
      {nota && <div className="db-tarjeta-nota">{nota}</div>}
      <div className="db-tarjeta-cuerpo">{children}</div>
    </div>
  );
}

export function Grilla({ children }) {
  return <div className="db-grid">{children}</div>;
}

export function Subtitulo({ children }) {
  return <div className="db-sub">{children}</div>;
}

export function EstadoVacio({ emoji, texto }) {
  return (
    <div className="db-vacio">
      <div aria-hidden="true">{emoji}</div>
      {texto}
    </div>
  );
}

// Proporción de una variable con pocas categorías (Sí/No, Femenino/Masculino…):
// número grande del porcentaje destacado + barra apilada + leyenda con conteos.
// Más legible que una dona, sobre todo en celular.
//   destacar: la categoría cuyo % va en grande (ej. "Sí").
//   colores: { categoria: color } — por defecto: destacada = acento, "No" = gris.
export function Proporcion({ datos, destacar, acento, colores = {}, etiqueta }) {
  const entradas = Object.entries(datos || {}).filter(([, v]) => v > 0);
  const total = entradas.reduce((a, [, v]) => a + v, 0);
  if (!total) return <div className="text-muted" style={{ fontSize: 13 }}>Sin datos</div>;

  // Orden estable: destacada primero, "No" al final.
  entradas.sort((a, b) => {
    const peso = (k) => (k === destacar ? 0 : k === "No" ? 2 : 1);
    return peso(a[0]) - peso(b[0]) || b[1] - a[1];
  });
  const colorDe = (k, i) =>
    colores[k] || (k === destacar ? acento : k === "No" ? GRIS_NEUTRO : i === 0 ? acento : GRIS_OSCURO);

  const valorDestacado = datos?.[destacar] || 0;

  return (
    <div>
      <div className="db-prop-valor">
        {pct(valorDestacado, total)}%<span>{etiqueta || destacar}</span>
      </div>
      <div className="db-prop-barra" role="img" aria-label={entradas.map(([k, v]) => `${k}: ${v}`).join(", ")}>
        {entradas.map(([k, v], i) => (
          <div key={k} title={`${k}: ${num(v)} (${pct(v, total)}%)`} style={{ width: `${(v / total) * 100}%`, background: colorDe(k, i) }} />
        ))}
      </div>
      <div className="db-leyenda">
        {entradas.map(([k, v], i) => (
          <span key={k}><i style={{ background: colorDe(k, i) }} />{k} <b>{num(v)}</b></span>
        ))}
      </div>
    </div>
  );
}
